import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/close_btn.png'


const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "file-upload-popup" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { class: "popup_title" }
const _hoisted_5 = { class: "popup-body" }
const _hoisted_6 = { class: "contact_body" }
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = { class: "popup-footer" }

import { ref, onMounted } from "vue";
import anncounceAPI from "@/api/announceAPI";
import { Announce, AnnounceContact } from "@/common/types";
import { phoneNumberFormat } from "@/utils/utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactPop',
  props: {
    announceData: {},
    수주수행구분: {}
  },
  emits: ["closePopup"],
  setup(__props: any, { emit: __emit }) {

const announceData = ref({} as Announce & Record<string, any>);
onMounted(() => {
  announceData.value = JSON.parse(JSON.stringify(props.announceData));
});

const props = __props;

const emit = __emit;
const modify = () => {
  // 공고순번 추출
  const 공고순번 = announceData.value.공고순번;

  if (!공고순번) {
    alert("공고순번 값이 없습니다.");
    return;
  }
  // 데이터 객체 생성
  let data: Partial<AnnounceContact> = {};
  // 수주 또는 수행에 따른 데이터 설정
  if (props.수주수행구분 === "수주") {
    data.수주담당자이름1 = announceData.value.수주담당자이름1;
    data.수주담당자이름2 = announceData.value.수주담당자이름2;
    data.수주담당자이름3 = announceData.value.수주담당자이름3;
    data.수주담당자전화번호1 = announceData.value.수주담당자전화번호1 ? announceData.value.수주담당자전화번호1.replaceAll("-", "") : "";
    data.수주담당자전화번호2 = announceData.value.수주담당자전화번호2 ? announceData.value.수주담당자전화번호2.replaceAll("-", "") : "";
    data.수주담당자전화번호3 = announceData.value.수주담당자전화번호3 ? announceData.value.수주담당자전화번호3.replaceAll("-", "") : "";
    data.수주담당자직통번호1 = announceData.value.수주담당자직통번호1 ? announceData.value.수주담당자직통번호1.replaceAll("-", "") : "";
    data.수주담당자직통번호2 = announceData.value.수주담당자직통번호2 ? announceData.value.수주담당자직통번호2.replaceAll("-", "") : "";
    data.수주담당자직통번호3 = announceData.value.수주담당자직통번호3 ? announceData.value.수주담당자직통번호3.replaceAll("-", "") : "";
    data.수주담당자이메일1 = announceData.value.수주담당자이메일1;
    data.수주담당자이메일2 = announceData.value.수주담당자이메일2;
    data.수주담당자이메일3 = announceData.value.수주담당자이메일3;
    data.수주담당자비고1 = announceData.value.수주담당자비고1;
    data.수주담당자비고2 = announceData.value.수주담당자비고2;
    data.수주담당자비고3 = announceData.value.수주담당자비고3;
  } else if (props.수주수행구분 === "수행") {
    data.수행담당자이름1 = announceData.value.수행담당자이름1;
    data.수행담당자이름2 = announceData.value.수행담당자이름2;
    data.수행담당자이름3 = announceData.value.수행담당자이름3;
    data.수행담당자전화번호1 = announceData.value.수행담당자전화번호1 ? announceData.value.수행담당자전화번호1.replaceAll("-", "") : "";
    data.수행담당자전화번호2 = announceData.value.수행담당자전화번호2 ? announceData.value.수행담당자전화번호2.replaceAll("-", "") : "";
    data.수행담당자전화번호3 = announceData.value.수행담당자전화번호3 ? announceData.value.수행담당자전화번호3.replaceAll("-", "") : "";
    data.수행담당자직통번호1 = announceData.value.수행담당자직통번호1 ? announceData.value.수행담당자직통번호1.replaceAll("-", "") : "";
    data.수행담당자직통번호2 = announceData.value.수행담당자직통번호2 ? announceData.value.수행담당자직통번호2.replaceAll("-", "") : "";
    data.수행담당자직통번호3 = announceData.value.수행담당자직통번호3 ? announceData.value.수행담당자직통번호3.replaceAll("-", "") : "";
    data.수행담당자이메일1 = announceData.value.수행담당자이메일1;
    data.수행담당자이메일2 = announceData.value.수행담당자이메일2;
    data.수행담당자이메일3 = announceData.value.수행담당자이메일3;
    data.수행담당자비고1 = announceData.value.수행담당자비고1;
    data.수행담당자비고2 = announceData.value.수행담당자비고2;
    data.수행담당자비고3 = announceData.value.수행담당자비고3;
  }

  // API 호출
  anncounceAPI.modifyContact(data, 공고순번).then((res) => {
    if (res.data.success) {
      alert("등록이 완료되었습니다.");
      closePopup(true); // 팝업 닫기
    }
  });
};

const closePopup = (refresh: boolean) => {
  emit("closePopup", { popupType: "contact", refresh });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "popup_cover" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(props.수주수행구분) + " 담당자 연락처", 1),
        _createElementVNode("img", {
          src: _imports_0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (closePopup(false))),
          class: "close_icon"
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"contact_header\" data-v-160aeb4a><div class=\"contact_header_column\" data-v-160aeb4a>성함</div><div class=\"contact_header_column\" data-v-160aeb4a>연락처</div><div class=\"contact_header_column\" data-v-160aeb4a>직통번호</div><div class=\"contact_header_column\" data-v-160aeb4a>이메일</div><div class=\"contact_header_column\" data-v-160aeb4a>비고</div></div>", 1)),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['1', '2', '3'], (item, index) => {
            return _createElementVNode("div", {
              class: "contact_div",
              key: index
            }, [
              _withDirectives(_createElementVNode("input", {
                class: "contact_inp",
                type: "text",
                "onUpdate:modelValue": ($event: any) => ((announceData.value[`${props.수주수행구분}담당자이름${item}`]) = $event)
              }, null, 8, _hoisted_7), [
                [_vModelText, announceData.value[`${props.수주수행구분}담당자이름${item}`]]
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "contact_inp",
                type: "text",
                "onUpdate:modelValue": ($event: any) => ((announceData.value[`${props.수주수행구분}담당자전화번호${item}`]) = $event)
              }, null, 8, _hoisted_8), [
                [_vModelText, announceData.value[`${props.수주수행구분}담당자전화번호${item}`]]
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "contact_inp",
                type: "text",
                "onUpdate:modelValue": ($event: any) => ((announceData.value[`${props.수주수행구분}담당자직통번호${item}`]) = $event)
              }, null, 8, _hoisted_9), [
                [_vModelText, announceData.value[`${props.수주수행구분}담당자직통번호${item}`]]
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "contact_inp",
                type: "text",
                "onUpdate:modelValue": ($event: any) => ((announceData.value[`${props.수주수행구분}담당자이메일${item}`]) = $event)
              }, null, 8, _hoisted_10), [
                [_vModelText, announceData.value[`${props.수주수행구분}담당자이메일${item}`]]
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "contact_inp",
                type: "text",
                "onUpdate:modelValue": ($event: any) => ((announceData.value[`${props.수주수행구분}담당자비고${item}`]) = $event)
              }, null, 8, _hoisted_11), [
                [_vModelText, announceData.value[`${props.수주수행구분}담당자비고${item}`]]
              ])
            ])
          }), 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", {
          class: "popup_close_btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (closePopup(false)))
        }, "취소"),
        _createElementVNode("div", {
          class: "popup_confirm_btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (modify()))
        }, "저장")
      ])
    ])
  ]))
}
}

})